import { useStore, useStoreUI } from '@assets/model/Store';
import { observer } from 'mobx-react';
import { Flex } from '../UI/Flex/Flex';

import { useState } from 'react';
import { Button } from 'react-bootstrap';
import * as style from './ModalEditNarrative.module.less';

interface ModalEditNarrativeProps {
    hypothesis: string;
    ui_display: string;
    onEdit: (newHypothesis: string, newUiDisplay: string) => void;
    onDelete: () => void;
}

export const ModalEditNarrative = observer((props: ModalEditNarrativeProps) => {
    const [val_hyp, setHyp] = useState<string>(props.hypothesis);
    const [val_display, setDisplay] = useState<string>(props.ui_display);

    const onSubmitSelection = () => {
        props.onEdit(val_hyp, val_display);
    };

    return (
        <>
            <Flex fillCell={true} direction="column" alignItems="start">
                <div className={style.title}>Title</div>
                <input
                    style={{
                        width: '100%'
                    }}
                    type="text"
                    value={val_display}
                    onChange={e => {
                        setDisplay(e.target.value);
                    }}
                ></input>

                <div className={style.title}>Hypothesis</div>
                <textarea
                    style={{
                        width: '100%',
                        height: '100%',
                        maxHeight: '350px'
                    }}
                    value={val_hyp}
                    onChange={e => {
                        setHyp(e.target.value);
                    }}
                />
                <div style={{ flexGrow: 1 }}></div>
                <div className={style.seperator}></div>
                <Flex direction="row" style={{ width: '100%', height: '40px' }}>
                    <Button
                        variant="danger"
                        onClick={() => {
                            if (confirm('Are you sure?')) props.onDelete();
                        }}
                    >
                        Delete
                        <i
                            style={{ paddingLeft: '5px' }}
                            className="bi bi-trash"
                        ></i>
                    </Button>

                    <div style={{ flexGrow: 1 }}></div>
                    <Button
                        style={{ marginRight: '20px' }}
                        onClick={() => {
                            const ui = useStoreUI();
                            ui.modal = null;
                        }}
                        className={style.cancelButton}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={onSubmitSelection}
                        className={style.confirmButton}
                    >
                        Confirm
                    </Button>
                </Flex>
            </Flex>
        </>
    );
});
